module.exports = __webpack_public_path__ + "img/food wars sized.5b05fbba.png";